import React, { Component } from 'react';
import { getTextureUrl } from '../Common/TextureTools';
import './game-state-bar.css';


export class GameStateBar extends Component {

    constructor(props) {
        super(props);
        this.state = {gameStatus: this.props.gameData.status}
        this.ghostWave = getTextureUrl(164);
        this.draft = getTextureUrl(165);
        this.actions = getTextureUrl(166);
        this.score = getTextureUrl(167);
    }
    componentDidMount() {
        window.addEventListener('game-event',
            this.updateStatusByGame);
        window.addEventListener('game-status-update-event',
            this.updateStatus);
    }
    componentWillUnmount() {
        window.removeEventListener('game-event',
            this.updateStatusByGame);
        window.removeEventListener('game-status-update-event',
            this.updateStatus);
    }

    updateStatus = (e) => {
        const newStatus = e.detail;
        this.setState({gameStatus: newStatus});
    }

    updateStatusByGame = (e) => {
        const newStatus = e.detail.status;
        this.setState({gameStatus: newStatus});
    }

    render() {
        let gameStatus = this.state.gameStatus;

        const GHOST_STARTER_ID = 8;
        let isGhostWave = gameStatus === GHOST_STARTER_ID;
        let ghostWaveClassName = 'game-state-icon-container';
        if (isGhostWave) ghostWaveClassName += ' current-state-border';

        const DRAFT_ID = 9;
        let isDraft = gameStatus === DRAFT_ID;
        let draftClassName = 'game-state-icon-container';
        if (isDraft) draftClassName += ' current-state-border';

        const SCORING_ID = 4;
        let isScoring = gameStatus === SCORING_ID;
        let scoringClassName = 'game-state-icon-container';
        if (isScoring) scoringClassName += ' current-state-border';

        let isTakingTurns = gameStatus === 3;
        let actionsClassName = 'game-state-icon-container';
        if (isTakingTurns) actionsClassName += ' current-state-border';

        if (!isGhostWave && !isDraft && !isScoring && !isTakingTurns) {
            actionsClassName += ' current-state-border';
        }

        return (<div className={'game-state-bar'}
                     onMouseEnter={this.showGrid}
                     onMouseLeave={this.hideGrid}
            >
                <div className={ghostWaveClassName}>
                    <img src={this.ghostWave}
                         alt={'Ghost Wave'}
                         title={'Ghost Wave'}
                         className={'game-state-icon'}
                    />
                </div>

                <div className={draftClassName}>
                    <img src={this.draft}
                         alt={'Draft'}
                         title={'Draft'}
                         className={'game-state-icon'}
                    />
                </div>

                <div className={actionsClassName}>
                    <img src={this.actions}
                         alt={'Actions'}
                         title={'Actions'}
                         className={'game-state-icon'}
                    />
                </div>

                <div className={scoringClassName}>
                    <img src={this.score}
                         alt={'Score'}
                         title={'Score'}
                         className={'game-state-icon'}
                    />
                </div>
            </div>
        );
    }
}
